import { useState } from 'react';
import { TextField, Button } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import AddGeneGroupButton from './AddGeneGroupButton';

const GeneGroupDialog = ({ map, genePMTilesLocation, catalogId, geneList, handleCloseGeneGroupDialog }) => {

	const [geneGroupItems, setGeneGroupItems] = useState([]);

	// set filter limit to avoid latency when clicking autocomplete editbox
	const filterOptions = createFilterOptions({
		matchFrom: 'any',
		limit: 100
	});

	const handleInputChange = (event, newInputValue, reason) => {
		if (event.type === "paste" && reason === "paste") {
			const text = newInputValue.trim();
			let separator = null;
			if (text.includes(",")) {
				separator = ",";
			} else if (text.includes("\r\n")) {
				separator = "\r\n";
			} else if (text.includes("\t")) {
				separator = "\t";
			} else if (text.includes(" ")) {
				separator = "/\s+/";
			}
			const geneNames = text.toLocaleLowerCase().split(separator);
			if (geneNames && geneNames.length > 0) {
				const filteredGenes = geneList.filter(item => {
					const nameLowercased = item.gene.toLocaleLowerCase();
					return geneNames.includes(nameLowercased);
				});
				setGeneGroupItems(filteredGenes);
			}
		}
	}

	const handlePaste = (event) => {
		// Get text from the clipboard
		const pasteText = event.clipboardData.getData('text');
		const text = pasteText.trim();
		let separator = null;
		if (text.includes(",")) {
			separator = ",";
		} else if (text.includes("\r\n")) {
			separator = "\r\n";
		} else if (text.includes("\t")) {
			separator = "\t";
		} else if (text.includes(" ")) {
			separator = "/\s+/";
		}
		const geneNames = text.toLocaleLowerCase().split(separator);
		if (geneNames && geneNames.length > 0) {
			const filteredGenes = geneList.filter(item => {
				const nameLowercased = item.gene.toLocaleLowerCase();
				return geneNames.includes(nameLowercased);
			});
			if (filteredGenes && filteredGenes.length > 0) {
				setGeneGroupItems(filteredGenes);
			}
		}
	};

	return (
		<div className='gene-group-container'>
			<div className='gene-group-autocomplete'>
				<Autocomplete
					multiple
					id="size-small-outlined-multi"
					size="small"
					options={geneList}
					filterOptions={filterOptions}
					getOptionLabel={(option) => option.gene}
					value={geneGroupItems}
					onChange={(event, newValue) => {
						setGeneGroupItems(newValue);
					}}
					onInputChange={handleInputChange}
					renderInput={(params) => (
						<TextField
							{...params}
							onPaste={handlePaste}
							label="Type in gene name to start"
							placeholder="Genes"
						/>
					)}
				/>
			</div>
			<div className='gene-group-button-container'>
				<div className='gene-group-button'>
					<Button
						className='gene-group-button'
						variant="outlined"
						color="success"
						size="small"
						onClick={() => {
							handleCloseGeneGroupDialog();
							setGeneGroupItems([]);
						}}
					>
						Cancel
					</Button>
				</div>
				<div className='gene-group-button'>
					<AddGeneGroupButton
						geneGroupItems={geneGroupItems}
						map={map}
						genePMTilesLocation={genePMTilesLocation}
						catalogId={catalogId}
						clearGeneGroupItems={() => {
							setGeneGroupItems([]);
						}}
						handleCloseGeneGroupDialog={handleCloseGeneGroupDialog}
					/>
				</div>
			</div>
		</div>
	)
}

export default GeneGroupDialog;